import React from "react";
import values from "../../values";
import Context from "../../context";
import { Components } from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";

const ClientScreen = () => {
  const { requestClient, setRequestClient, resultClient } = React.useContext(
    Context.ClientScreen
  );

  return (
    <CustomView.Container id="driver-screen-container">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column
          extraLarge={3}
          large={5}
          medium={5}
          className="bread-crumb-wrapper"
        >
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column
          extraLarge={4}
          large={5}
          medium={7}
          className="search-and-filter-wrapper"
        >
          {/* <Components.Create /> */}

          <Components.Filter />
          <Components.Search />
        </CustomView.Column>
      </CustomView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={values.tableHeaders.CLIENT_HEADERS} />
          {resultClient?.status === "loading" ? (
            <TableLoading />
          ) : (
            <Components.Body data={resultClient?.data?.result?.docs} />
          )}
        </table>
      </div>
      {resultClient?.status === "success" &&
        resultClient?.data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestClient?.page}
              totalPages={resultClient?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestClient!({ ...requestClient, page })
              }
            />
          </div>
        )}
      <Components.Update />
      <Components.Detail />
      <Components.Delete />
    </CustomView.Container>
  );
};

export default ClientScreen;
